import React from "react";
import styled from "styled-components";
import { useAuth } from "../../context/AuthContext";
import { useUserProgress } from "../../lib/gamification";

const Row = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;

const Heart = styled.span`
  display: inline-block;
  width: 14px;
  height: 14px;
`;

const SubText = styled.span`
  margin-left: 8px;
  font-family: 'Space Mono', monospace;
  font-size: 11px;
  color: var(--nd-text-secondary);
`;

const MAX = 5;

const HeartSvg = ({ filled }) => (
  <svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true">
    <path
      d="M7 12 L1.5 6.5 A3 3 0 0 1 7 3 A3 3 0 0 1 12.5 6.5 Z"
      fill={filled ? "var(--nd-text-display)" : "none"}
      stroke="var(--nd-text-display)"
      strokeWidth="1"
    />
  </svg>
);

const formatRegen = (livesUpdatedAt, lives) => {
  if (!livesUpdatedAt || lives >= MAX) return null;
  const last = livesUpdatedAt.toMillis
    ? livesUpdatedAt.toMillis()
    : new Date(livesUpdatedAt).getTime();
  const next = last + 4 * 60 * 60 * 1000;
  const remaining = Math.max(0, next - Date.now());
  const h = Math.floor(remaining / 3600000);
  const m = Math.floor((remaining % 3600000) / 60000);
  return `+1 in ${h.toString().padStart(2, "0")}:${m.toString().padStart(2, "0")}`;
};

const LivesIndicator = () => {
  const { user } = useAuth();
  const { data } = useUserProgress(user && user.uid);
  if (!user) return null;
  const lives = data && typeof data.lives === "number" ? data.lives : MAX;
  const sub = formatRegen(data && data.livesUpdatedAt, lives);
  return (
    <Row aria-label={`${lives} of ${MAX} lives`}>
      {Array.from({ length: MAX }).map((_, i) => (
        <Heart key={i}>
          <HeartSvg filled={i < lives} />
        </Heart>
      ))}
      {sub && <SubText>{sub}</SubText>}
    </Row>
  );
};

export default LivesIndicator;
